module.exports = __webpack_public_path__ + "static/media/GINGER LEMON.1904c245.jpg";